import React from "react";
import { styled } from "@mui/material/styles";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";

const StyledDatePickerWrapper = styled("div")(() => ({
  margin: "8px 0px",
  backgroundColor: "white",
}));

const DatePickerWidget = ({ label, value, onChange, disabled, minDate }) => {
  const validValue = value ? dayjs(value, "DD-MM-YYYY", true) : null;

  const handleDateChange = (date) => {
    const formattedDate = date ? dayjs(date).format("DD-MM-YYYY") : null;
    onChange(formattedDate);
  };

  return (
    <StyledDatePickerWrapper>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          label={label}
          value={validValue && validValue.isValid() ? validValue : null}
          onChange={handleDateChange}
          disabled={disabled}
          minDate={minDate ? dayjs(minDate, "DD-MM-YYYY") : undefined}
        />
      </LocalizationProvider>
    </StyledDatePickerWrapper>
  );
};

export default DatePickerWidget;
